import { useState, useEffect } from "react";
import AssociatesCard from "../cards/AssociatesCard";
import useWindowSize from "../useWindowSize";

const DoctorsSection = ({ employees }) => {
    const [width] = useWindowSize();

    return(
        <div>
            <div className="bg-theme pt-5">
                <div className="coachesHeading mb-5">
                    <div className="coachesHeading1">
                        <div className="text-white fw-700 fo-50">BOARD OF DOCTORS AND EXPERTS</div>
                    </div>
                    <div className="coachesHeading2">
                        <div></div>
                    </div>
                </div>
                <EmployeeGrid associates={employees} eachRow={width > 768 ? 4 : 2}/>
            </div>
        </div>
    )
}

export default DoctorsSection;


const EmployeeGrid = ({ associates, eachRow=4 }) => {
    const [ rows, setRows ] = useState([]);
  
    useEffect(() => {
      let temp = [];
      const rowCount = Math.ceil(associates.length / eachRow);
      for(let i = 0; i < rowCount; i++){
        temp.push(associates.slice(eachRow*i, (eachRow*i)+eachRow));
      }
      setRows(temp);
    }, [eachRow, associates]) 
    return(
      <div>
        { rows.map(( row, index ) => <EmployeeRow associates={row} key={index} />) }
      </div>
    )
  }
  
  const EmployeeRow = ({ associates }) => {
      return (
          <div className="coachesSetion d-block">
              <div className="coachList">
                  <div className="row bg-theme m-0 mb-5 justify-content-center">
                      {associates.map((associate, index) => (
                          <AssociatesCard associate={associate} key={index} />
                      ))}
                  </div>
              </div>
          </div>
      );
  };  
